import { useAtomValue } from 'jotai';

import { hasActiveFilterAtom } from 'atoms/filters/sim-products';

export const useHasActiveFilters = () => {
  return useAtomValue(hasActiveFilterAtom);
};
